import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import VariablePicker from './../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

function Assign({ action, variables, setOpenVariable, setField, disabled, outputVisible, visible }) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.DATA-TABLE.ASSIGN.";

  return (
    <div>
      <div className="conf-field-container">
        <FieldLabel name={t(label + "ASSIGN-VALUE")} is_required />
        <TextInput
          action={action}
          inputName="assignValue"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired
          fieldType="string" displayName={t(label + 'ASSIGN-VALUE')}
          disabled={disabled} setField={setField}
          hideRequired
        />
      </div>
      {
        !outputVisible &&
        <div className={`conf-field-container ${visible ? "display-none" : ""}`}>
          <FieldLabel name={t(label + "ASSIGN-SOURCE")} is_required />
          <VariablePicker
            action={action}
            inputName="assignSource"
            variables={variables}
            setOpenVariable={setOpenVariable}
            filter="string"
            isRequired
            disabled={disabled}
            hideRequired
          />
          <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
        </div>
      }

    </div>
  );
}

export default Assign;
